<template>
	<v-modal :is-open="isOpen" class="bg-white" @close="$emit('close')">
		<v-modal-header @close="$emit('close')">
			{{ t("login") }}
		</v-modal-header>

		<div class="my-md h-max bg-gray-50 p-0">
			<v-login-ingress></v-login-ingress>

			<div id="auth0-lock-container"></div>
		</div>
	</v-modal>
</template>

<script lang="ts" setup>
import {watchDebounced} from "@vueuse/core";

import {useAuth} from "@pkg/shared/composables/use-auth";

const properties = defineProps<{
	isOpen: boolean;
}>();

defineEmits<{
	(event: "close"): void;
}>();

const {t} = useI18n();
const {showLoginForm, hideLoginForm} = useAuth();

watchDebounced(
	() => properties.isOpen,
	(value) => {
		if (value) {
			showLoginForm();
		} else {
			hideLoginForm();
		}
	},
	{debounce: 10},
);

// Old school login by navigating to auth0's login page, see git @ 61d36b2e
// async function doLogin() {
// await login(window.location.pathname);
// }
</script>

<style>
@reference "~/assets/css/tailwind.css";

body .auth0-lock.auth0-lock {
	@apply font-sans;

	.auth0-lock-center {
		@apply p-6;
	}

	.auth0-lock-widget {
		@apply w-full;
	}

	.auth0-lock-header {
		@apply hidden;
	}

	.auth0-lock-content-body-wrapper {
		@apply rounded-t-[5px] overflow-hidden;
	}

	.auth0-lock-tabs {
		@apply text-base;

		li {
			@apply pt-2 pb-2;
		}

		li span {
			@apply text-black;
		}

		li.auth0-lock-tabs-current span {
			@apply text-black font-bold;
		}
	}

	.auth0-lock-submit {
		@apply text-base font-bold;
	}

	.auth0-lock-cred-pane-internal-wrapper {
		@apply h-auto;
	}
}
</style>
